import { useLanguage } from "@/contexts/LanguageContext";

/**
 * useT — Landing V2 adapter for the inline `t(en, zh)` style used by
 * the new landing components. Returns a function that picks between
 * the English and Chinese value based on the existing LanguageContext.
 *
 * Existing key-based `t('namespace.key')` continues to work via useLanguage().t.
 */
export function useT() {
  const { language } = useLanguage();
  return function t<T>(en: T, zh: T): T {
    return language === "zh" ? zh : en;
  };
}

export function useLang() {
  const { language, setLanguage } = useLanguage();
  return { lang: language, setLang: setLanguage };
}
